import React from "react";
import { Award, Car, ShieldCheck, Truck, Headphones, Package } from "lucide-react";
import { reasons, company } from "../mock";
import { usePreventivo } from "./PreventivoContext";

const iconMap = { Award, Car, ShieldCheck, Truck, Headphones, Package };

const WhyChoose = () => {
  const { openPreventivo } = usePreventivo();
  return (
    <section className="bg-[#f4f6f9] py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center max-w-2xl mx-auto">
          <h2 className="font-display text-[#0f2846] text-3xl md:text-4xl font-bold">Perché scegliere {company.shortName}</h2>
          <div className="w-24 h-1 bg-[#e8464a] mx-auto mt-4 rounded-full" />
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-12">
          {reasons.map((r, i) => {
            const Ic = iconMap[r.icon];
            return (
              <div key={i} className="bg-white rounded-2xl p-7 border border-slate-100 shadow-sm hover:shadow-lg hover:-translate-y-1 transition-all">
                <div className="w-12 h-12 rounded-xl bg-[#0f2846] flex items-center justify-center">
                  <Ic size={22} className="text-white" />
                </div>
                <h3 className="font-display font-bold text-[#0f2846] text-lg mt-5">{r.title}</h3>
                <p className="text-slate-500 text-sm mt-3 leading-relaxed">{r.desc}</p>
              </div>
            );
          })}
        </div>
        <div className="text-center mt-12">
          <button onClick={() => openPreventivo()} className="inline-flex items-center justify-center bg-[#e8464a] hover:bg-[#d43a3e] text-white font-semibold px-8 py-3.5 rounded-lg transition-all hover:-translate-y-0.5 shadow-lg shadow-[#e8464a]/30">
            Richiedi un preventivo gratuito
          </button>
        </div>
      </div>
    </section>
  );
};

export default WhyChoose;
